export default __webpack_public_path__ + "static/arvo-latin-400-normal-eee79ea9c90aeaf1efe6bbabf290a6af.woff2";